export default __webpack_public_path__ + "static/media/send-message.0cff89d4.svg";